module.exports = __webpack_public_path__ + "assets/img/smartTV-module4-3.ac5370d0.jpg";